exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-swipe-item{position:relative;-webkit-flex-shrink:0;flex-shrink:0;width:100%;height:100%}", "", {"version":3,"sources":["/Users/hangz/Work/projects/vision-h5/node_modules/vant/es/swipe-item/index.css"],"names":[],"mappings":"AAAA,gBAAgB,kBAAkB,sBAAsB,cAAc,WAAW,WAAW,CAAC","file":"index.css","sourcesContent":[".van-swipe-item{position:relative;-webkit-flex-shrink:0;flex-shrink:0;width:100%;height:100%}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/swipe-item/index.css
// module id = liWd
// module chunks = 213